import { type FC, useState } from "react";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useToast } from "@/hooks/ui/use-toast";
import { useAuth } from "@/hooks/useAuth";
import { Upload, Trash2 } from "lucide-react";

export const AvatarForm: FC = () => {
	const { user } = useAuth();
	const { toast } = useToast();
	const [isUploading, setIsUploading] = useState(false);

	const handleFileChange = async (
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		const file = event.target.files?.[0];
		if (!file) return;

		try {
			setIsUploading(true);
			// TODO: アバター画像アップロードのAPI呼び出し
			toast({
				title: "プロフィール画像を更新しました",
				description: "変更内容が保存されました",
			});
		} catch (error) {
			toast({
				title: "エラーが発生しました",
				description: "画像のアップロードに失敗しました",
				variant: "destructive",
			});
		} finally {
			setIsUploading(false);
		}
	};

	const handleRemoveAvatar = async () => {
		try {
			// TODO: アバター画像削除のAPI呼び出し
			toast({
				title: "プロフィール画像を削除しました",
			});
		} catch (error) {
			toast({
				title: "エラーが発生しました",
				description: "画像の削除に失敗しました",
				variant: "destructive",
			});
		}
	};

	return (
		<div className="space-y-6">
			<div className="flex items-center gap-6">
				<Avatar className="h-24 w-24">
					<AvatarImage src={user?.avatarUrl} />
					<AvatarFallback>
						{user?.username?.[0]?.toUpperCase() || "U"}
					</AvatarFallback>
				</Avatar>
				<div className="space-y-2">
					<div className="space-x-2">
						<Button
							variant="secondary"
							size="sm"
							disabled={isUploading}
							onClick={() => document.getElementById("avatar-upload")?.click()}
						>
							<Upload className="mr-2 h-4 w-4" />
							画像をアップロード
						</Button>
						{user?.avatarUrl && (
							<Button
								variant="destructive"
								size="sm"
								disabled={isUploading}
								onClick={handleRemoveAvatar}
							>
								<Trash2 className="mr-2 h-4 w-4" />
								削除
							</Button>
						)}
					</div>
					<input
						id="avatar-upload"
						type="file"
						accept="image/*"
						className="hidden"
						onChange={handleFileChange}
					/>
					<p className="text-sm text-muted-foreground">
						推奨: 500x500ピクセル以上のJPEG、PNG形式
					</p>
				</div>
			</div>
		</div>
	);
};
